// ADDRESS PLANES BY KEY, NEVER BY POSITION.

/* * Behavior-Classified Zones: the three axes, each a 0–100 percentile on an ABSOLUTE domain. */
export const BEHAVIOR_PLANES = {
  moisture: {
    post: "moisture_post",
    pre: "moisture_pre",
    label: "Effective Moisture",
  },
  productivity: {
    post: "productivity_pct",
    pre: "productivity_pct",
    label: "Productivity",
  },
  fertility: {
    post: "fertility_post",
    pre: "fertility_pre",
    label: "Fertility",
  },
} as const;

/*
 *
 * Multi-Input, Relative Zones: one plane per panel.
 */
export const RELATIVE_PLANES = {
  soil: { key: "mapunit", label: "Soil Type" },
  water: { key: "twi", label: "Topographic Water Flow" },
  yield: { key: "simyield_corn", label: "Simulated Yield" },
  /* * only if a field somehow lacks the modelled yield — NDVI peak is the documented stand-in */
  yieldFallback: { key: "ndvi_peak", label: "NDVI Peak" },
} as const;

/* * Classic Grid: the layers that arrive, then the mask that combines them. */
export const GRID_PLANES = {
  waterway: { key: "waterway", label: "Waterways" },
  boundary: { key: "dist_boundary", label: "Distance from Boundary" },
  insideCorner: { key: "inside_corner", label: "Inside Corners" },
  /*
   *
   * THE EXCLUSION PLANE IS BITS, NOT A SCALE.
   */
  exclusion: { key: "grid_exclusion", label: "Sampling Exclusions" },
} as const;

/* * Bit positions in `grid_exclusion`, low bit first — compute's `bit_labels`, mirrored for lookup. */
export const EXCLUSION_BITS = {
  waterway: 0,
  waterwayBuffer: 1,
  insideCorner: 2,
  boundary: 3,
} as const;

/* * Index of a served plane by key, or -1. */
export function planeIndex(keys: readonly string[], key: string): number {
  return keys.indexOf(key);
}

/*
 *
 * "POST IF IT HAS VALUES, ELSE PRE" ALREADY EXISTS ELSEWHERE IN THE FE, and this is deliberately
 * the same rule rather than a new one: an animation that picked the other fork would show pre-fork
 * pixels underneath post-fork zones.
 */
export function forkedPlaneIndex(
  keys: readonly string[],
  cells: { values: (number | null)[] }[],
  axis: { post: string; pre: string },
): number {
  const post = planeIndex(keys, axis.post);
  if (post >= 0 && cells.some((c) => c.values[post] != null)) return post;
  return planeIndex(keys, axis.pre);
}
